import { useEffect } from "react";

function PurchaseOrderFilter(props) {
  useEffect(() => {}, [props?.bulkActionData]);

  const createSelectItems = () => {
    let items = [];
    props?.bulkActionData?.forEach((item, i) => {
      items.push(
        <option key={i} value={i}>
          {item.filtering_name}
        </option>
      );
    });

    return items;
  };

  const handleChange = value => {
    props.onSelectBulkAction(value);
  };

  return (
    <>
      <select
        className="w-[250px] h-[40px] text-sm border border-gray-200 rounded-md outline-none focus:outline-none ring-1 ring-gray-200"
        onChange={handleChange}
      >
        {createSelectItems()}
      </select>
    </>
  );
}

export default PurchaseOrderFilter;
